import React from 'react';

export default function PWPLogo({ size = 40, className }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 98"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* 5-pointed star */}
            <polygon
                points="50,14 53.5,23.1 63.3,23.7 55.7,29.9 58.2,39.3 50,34 41.8,39.3 44.3,29.9 36.7,23.7 46.5,23.1"
                fill="#00d9ff"
            />

            {/* Left outer C-arc */}
            <path d="M 21,33 A 38,38 0 0,0 21,81" stroke="#00d9ff" strokeWidth="3" strokeLinecap="round" />
            {/* Left inner C-arc */}
            <path d="M 28,38 A 29,29 0 0,0 28,76" stroke="#00d9ff" strokeWidth="2" strokeLinecap="round" opacity="0.65" />

            {/* Right outer C-arc */}
            <path d="M 79,33 A 38,38 0 0,1 79,81" stroke="#00d9ff" strokeWidth="3" strokeLinecap="round" />
            {/* Right inner C-arc */}
            <path d="M 72,38 A 29,29 0 0,1 72,76" stroke="#00d9ff" strokeWidth="2" strokeLinecap="round" opacity="0.65" />

            {/* Bottom connecting arc */}
            <path d="M 21,81 A 32,14 0 0,1 79,81" stroke="#00d9ff" strokeWidth="2.5" strokeLinecap="round" opacity="0.85" />
        </svg>
    );
}
